import angular from 'angular';

class RoutingCodeSvc {
    /* @ngInject */
    constructor(CONF, $filter, RoutingCodeDA) {
        this.CONF = CONF;
        this.$filter = $filter;
        this.routingCodeDA = RoutingCodeDA;
    }

    /**
     * Récupération des codes routage d'une sous-entité.
     */
    getRoutingCodes(subEntityId) {
        return this.routingCodeDA.getRoutingCodes(subEntityId);
    }

    /**
     * Création/Modification d'un code routage.
     */

    createUpdateRouting(subEntityId, routingCode) {
        return this.routingCodeDA.createUpdateRouting(subEntityId, routingCode);
    }

    /**
     * Récupère les détails d'un code routage
     */

    getRoutingCodeDetails(routingCodeId) {
        return this.routingCodeDA.getRoutingCodeDetails(routingCodeId);
    }
}

angular.module('app.principal').service('RoutingCodeSvc', RoutingCodeSvc);